/* eslint-disable @typescript-eslint/no-explicit-any */
// problem with string[] type
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import ChipMultiSelect from 'components/common/formElements/chipMultiSelect';
import RadiusInput from 'components/common/formElements/radiusInput';
import ContainerWithShadow from 'components/common/ContainerWithShadow';
import Title from 'components/common/Title';
import _ from 'lodash';
import FormControl from '@material-ui/core/FormControl';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import style from 'components/common/calendar/index.module.scss';
import styles from './styles.module.scss';

interface Props {
  setGrade: Dispatch<SetStateAction<string[]>>;
  setSkills: Dispatch<SetStateAction<string[]>>;
  setInterests: Dispatch<SetStateAction<string[]>>;
  requestError: string[];
  skills: string[];
  interests: string[];
  grade: string[];
  name: string;
  handleSetName: (e: React.FormEvent<HTMLInputElement>) => void;
  errors: {
    grades?: boolean;
    name?: boolean;
    interests?: boolean;
    skills?: boolean;
  };
}

const TeacherForm: React.FC<Props> = ({
  handleSetName,
  name,
  grade,
  interests,
  setInterests,
  // requestError,
  skills,
  setSkills,
  setGrade,
  errors,
}) => {
  const [preselectedGrades, setPreselectedGrades] = useState<
    {
      name: string;
      value: string[];
    }[]
  >([]);

  const useStyles = makeStyles(() =>
    createStyles({
      formControl: {
        margin: '0px ',
        minWidth: 120,
        width: '100%',
        height: 56,
        boxSizing: 'border-box',
        borderRadius: 100,
      },
    })
  );

  const classes = useStyles();

  const handleChangeGrade = (chip: any) => {
    const grades: string[] = [];
    chip.forEach((el: any) => {
      grades.push(...el.value);
    });
    setGrade(grades);
  };

  const handleChangeSkills = (chip: string) => {
    setSkills(_.flatten([...skills, chip]));
  };

  const handleDeleteSkill = (chips: any) => {
    setSkills(chips);
  };

  const handleChangeInterests = (chip: string) => {
    setInterests(_.flatten([...interests, chip]));
  };

  const handleDeleteInterest = (chips: any) => {
    setInterests(chips);
  };

  const gradeOptions = [
    { name: 'Pre K - 1', value: ['Pre K', '1'] },
    { name: 'Grade 2-5', value: ['2', '3', '4', '5'] },
    { name: 'Grade 6-8', value: ['6', '7', '8'] },
    { name: 'Grade 9-12', value: ['9', '10', '11', '12'] },
  ];

  useEffect(() => {
    const grades: {
      name: string;
      value: string[];
    }[] = [];
    gradeOptions.forEach((el) => {
      if (_.includes(grade, el.value[0])) {
        grades.push(el);
      }
    });
    setPreselectedGrades(grades);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [grade]);
  return (
    <ContainerWithShadow className={`${styles.root} profile`}>
      <Title className={styles.title}>Tell Us About This Anetapack</Title>
      <div>
        <div
          className={`${style.customSelect} ${style.margin} ${
            errors.grades ? styles.errorSelect : ''
          }`}
        >
          <FormControl className={`${classes.formControl} ${styles.formInput}`}>
            <RadiusInput
              className={styles.input}
              variant="outlined"
              label="What do you want to call it? (This is the name others will see)"
              type="text"
              name="name"
              onChange={handleSetName}
              value={name}
              error={errors.name || false}
            />
            <ChipMultiSelect
              options={gradeOptions}
              isObject
              onSelect={handleChangeGrade}
              onRemove={handleChangeGrade}
              title="What grade levels is it relevant for? Choose all that apply"
              selectedValues={preselectedGrades}
              selected={_.uniq(grade)}
              error={errors.grades || false}
              style={styles.mb24}
            />
            <ChipMultiSelect
              options={[
                'Math',
                'Science',
                'Language Arts',
                'Social Studies',
                'Music',
                'Art',
                'Other',
              ]}
              isObject={false}
              onSelect={handleChangeSkills}
              onRemove={(chip) => handleDeleteSkill(chip)}
              title="What learning skills does it most build? Choose up to 3"
              selected={_.uniq(skills)}
              error={errors.skills || false}
              selectedValues={_.uniq(skills)}
              style={styles.mb24}
            />
            <ChipMultiSelect
              isObject={false}
              options={[
                'Animals',
                'Funny',
                'Adventure',
                'Sports',
                'Fairy Tales',
                'Space',
                'Nature',
                'Cars',
                'Buildings',
                'Other',
              ]}
              onSelect={handleChangeInterests}
              onRemove={(chip) => handleDeleteInterest(chip)}
              title="What interests it most appeal to? Choose up to 3"
              selected={_.uniq(interests)}
              error={errors.interests || false}
              selectedValues={_.uniq(interests)}
            />
          </FormControl>
          {/* {!_.isEmpty(requestError) &&
            requestError.map((err) => (
              <span key={err} className="error-message">
                {err}
              </span>
            ))} */}
        </div>
      </div>
    </ContainerWithShadow>
  );
};
export default TeacherForm;
